// extracted by mini-css-extract-plugin
module.exports = {"topBar":"TopBarDefault_topBar_fEJUj","bannerBox":"TopBarDefault_bannerBox_34khf","bannerLogoIcon":"TopBarDefault_bannerLogoIcon_3Rf4n"};